import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Box, Button, Base, Block, t } from 'zf-web-components';
import { Common } from 'zf-types';
import dingtalk from '@assets/images/dingtalk.png';
import wecom from '@assets/images/wecom.png';
import { RootContext } from '@stores';
import { Captcha } from './captcha';
import { PrivacyPolicy } from './policy';
import styles from './index.module.less';
import type { FormProps, FormValues } from './types';
import type { ReactElement } from 'react';

function NormalLoginComponent({ store }: FormProps): ReactElement {
  const [form] = Base.Form.useForm<FormValues>();
  const { local } = useContext(RootContext);

  return (
    <div className={styles.formWrap}>
      <div className={styles.title}>{t('您好，欢迎使用')}</div>
      <Base.Form
        className={styles.form}
        size={'large'}
        layout='vertical'
        form={form}
        requiredMark={false}
        initialValues={{ code: local.code, id: local.id }}
        onValuesChange={store.onValuesChange.bind(store)}
      >
        <Base.Form.Item
          label={<span className={styles.label}>{t('用户名')}</span>}
          name='id'
          rules={store.getValidationRules('id')}
          normalize={value => value.trim()}
        >
          <Base.Input
            className={styles.input}
            variant='borderless'
            placeholder={t('请输入用户名')}
            autoComplete='username'
            onKeyUp={event => store.onInputKeyUp(event, form)}
          />
        </Base.Form.Item>
        <Base.Form.Item
          label={<span className={styles.label}>{t('密码')}</span>}
          name='password'
          rules={store.getValidationRules('password')}
          normalize={value => value.trim()}
        >
          <Base.Input.Password
            variant='borderless'
            className={styles.inputPass}
            placeholder={t('请输入密码')}
            autoComplete='current-password'
            onKeyUp={event => store.onInputKeyUp(event, form)}
          />
        </Base.Form.Item>
        <Block if={store.codeInputVisible}>
          <Base.Form.Item
            label={<span className={styles.label}>{t('企业码')}</span>}
            name='code'
            rules={store.getValidationRules('code')}
            normalize={value => value.trim()}
          >
            <Base.Input
              className={styles.input}
              variant='borderless'
              placeholder={t('请输入企业码')}
              onKeyUp={event => store.onInputKeyUp(event, form)}
            />
          </Base.Form.Item>
        </Block>
        <Block if={store.captchaImage.length > 0}>
          <Base.Form.Item
            label={<span className={styles.label}>{t('验证码')}</span>}
            name='captcha'
            rules={store.getValidationRules('captcha')}
          >
            <div className={styles.verifyInput}>
              <Base.Input
                className={styles.input}
                variant='borderless'
                placeholder={t('请输入验证码')}
                onKeyUp={event => store.onInputKeyUp(event, form)}
              />
              <Captcha
                isLoadingCaptcha={store.isCaptchaLoading}
                image={store.captchaImage}
                onChange={store.fetchCaptcha.bind(store)}
              />
            </div>
          </Base.Form.Item>
        </Block>
        <Button
          label={t('登录')}
          loading={store.isLoginBtnLoading}
          autoInsertSpace={false}
          type='primary'
          onClick={store.onLoginButtonClick.bind(store, form)}
          className={styles.loginBtn}
        />
        <Base.Divider style={{ borderColor: '#ccc' }} dashed>
          <span className={styles.otherText}>{t('其他登录方式')}</span>
        </Base.Divider>
        <Box className={styles.buttonGroup}>
          <img
            src={wecom}
            className={styles.logoBtn}
            onClick={store.onOtherLoginClick.bind(store, Common.LoginMethod.WECOM)}
          />
          <img
            src={dingtalk}
            className={styles.logoBtn}
            onClick={store.onOtherLoginClick.bind(store, Common.LoginMethod.DINGTALK)}
          />
        </Box>
        <div className={styles.policy}>
          <PrivacyPolicy />
        </div>
      </Base.Form>
    </div>
  );
}

export const NormalLogin = observer(NormalLoginComponent);
